// 40px round avatar with an initials fallback when no photo is available.
// Matches the Figma "User/Photo" (object-cover, fully rounded).

export const initials = (name?: string | null): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  return (
    (parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')
  );
};

type Props = { name?: string | null; src?: string | null };

const Avatar = ({ name, src }: Props) => (
  <span className="dashv2-avatar" aria-hidden="true">
    {src ? <img src={src} alt="" /> : initials(name).toUpperCase()}
  </span>
);

export default Avatar;
